import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { registerAdBannerMicrofrontend } from '../registerAdBannerMicrofrontend';
import { initializeGeoLinks } from '../../geo_links';
import { createContext } from './createContext';

export async function runApp() {
  const context = createContext();

  // Один раз на страницу, до рендера: мест под баннер может быть несколько, реестр — один.
  registerAdBannerMicrofrontend(context);

  const store = createApplicationState(context);

  renderApplication({ store, context });

  initializeGeoLinks();
}
